import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import React from "react";

import "./index.css";
import { sidebarActive } from "../../store/actions/sidebar";

const SidebarMenu = ({ activeSection }) => {
  const isActive = useSelector((state) => state.Sidebar.isActive);
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(sidebarActive(!isActive));
  };

  return (
    <>
      <div
        className={
          isActive ? "chips-exchange-sidebar active" : "chips-exchange-sidebar"
        }
      >
        <div className="sidebar-area">
          <ul className="sidebar-menu">
            <li>
              <Link
                className={`nav-item ${activeSection === "Banner" && "active"}`}
                to="/"
              >
                <i className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                  >
                    <path
                      d="M10.408 0.14779C10.2897 0.0520139 10.144 0 9.994 0C9.844 0 9.6983 0.0520139 9.58 0.14779L0 7.90526L0.828667 8.99359L2 8.04511V16.6154C2.0007 16.9824 2.14141 17.3341 2.3913 17.5936C2.6412 17.8532 2.97993 17.9993 3.33333 18H16.6667C17.0201 17.9993 17.3588 17.8532 17.6087 17.5936C17.8586 17.3341 17.9993 16.9824 18 16.6154V8.05134L19.1713 8.99982L20 7.91149L10.408 0.14779ZM11.3333 16.6154H8.66667V11.0768H11.3333V16.6154ZM12.6667 16.6154V11.0768C12.6663 10.7097 12.5257 10.3577 12.2758 10.0981C12.0258 9.8385 11.6868 9.69251 11.3333 9.69214H8.66667C8.31315 9.69251 7.97422 9.8385 7.72425 10.0981C7.47428 10.3577 7.33369 10.7097 7.33333 11.0768V16.6154H3.33333V6.96578L10 1.57259L16.6667 6.9727V16.6154H12.6667Z"
                      fill="#5A5A5A"
                    />
                  </svg>
                </i>
                Home
              </Link>
            </li>
            {/* <li>
                                <Link className={`nav-item ${activeSection == 'Singup' && 'active'}`} to="/SignUp">
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z" fill="white"/>
                                            <path d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z" fill="white"/>
                                            <path d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z" fill="white"/>
                                            <path d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z" fill="white"/>
                                        </svg>
                                    </i>
                                    Signup/Signin
                                </Link>
                            </li> */}
            <li>
              <Link
                className={`nav-item ${
                  activeSection === "ChipzBalance" && "active"
                }`}
                to="/ChipzBalance"
              >
                <i className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M2 7.625C2 6.7962 2.32924 6.00134 2.91529 5.41529C3.50134 4.82924 4.2962 4.5 5.125 4.5H18.875C19.7038 4.5 20.4987 4.82924 21.0847 5.41529C21.6708 6.00134 22 6.7962 22 7.625V16.375C22 17.2038 21.6708 17.9987 21.0847 18.5847C20.4987 19.1708 19.7038 19.5 18.875 19.5H5.125C4.2962 19.5 3.50134 19.1708 2.91529 18.5847C2.32924 17.9987 2 17.2038 2 16.375V7.625ZM5.125 5.75C4.62772 5.75 4.15081 5.94754 3.79917 6.29917C3.44754 6.65081 3.25 7.12772 3.25 7.625V9.25H20.75V7.625C20.75 7.12772 20.5525 6.65081 20.2008 6.29917C19.8492 5.94754 19.3723 5.75 18.875 5.75H5.125ZM3.25 16.375C3.25 16.8723 3.44754 17.3492 3.79917 17.7008C4.15081 18.0525 4.62772 18.25 5.125 18.25H18.875C19.3723 18.25 19.8492 18.0525 20.2008 17.7008C20.5525 17.3492 20.75 16.8723 20.75 16.375V10.5H3.25V16.375ZM15.625 14.75C15.4592 14.75 15.3003 14.8158 15.1831 14.9331C15.0658 15.0503 15 15.2092 15 15.375C15 15.5408 15.0658 15.6997 15.1831 15.8169C15.3003 15.9342 15.4592 16 15.625 16H18.375C18.5408 16 18.6997 15.9342 18.8169 15.8169C18.9342 15.6997 19 15.5408 19 15.375C19 15.2092 18.9342 15.0503 18.8169 14.9331C18.6997 14.8158 18.5408 14.75 18.375 14.75H15.625Z"
                      fill="#979797"
                    />
                  </svg>
                </i>
                Chipz Balance
              </Link>
            </li>
            <li>
              <Link
                className={`nav-item ${
                  activeSection === "TransactionHistory" && "active"
                }`}
                to="/TransactionHistory"
              >
                <i className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M7.5 13.5H13.5V15H7.5V13.5ZM7.5 9.75H16.5V11.25H7.5V9.75ZM7.5 17.25H11.25V18.75H7.5V17.25Z"
                      fill="#979797"
                    />
                    <path
                      d="M18.75 3.75H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H9C8.60218 1.5 8.22064 1.65804 7.93934 1.93934C7.65804 2.22064 7.5 2.60218 7.5 3V3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V21C3.75 21.3978 3.90804 21.7794 4.18934 22.0607C4.47064 22.342 4.85218 22.5 5.25 22.5H18.75C19.1478 22.5 19.5294 22.342 19.8107 22.0607C20.092 21.7794 20.25 21.3978 20.25 21V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75ZM9 3H15V6H9V3ZM18.75 21H5.25V5.25H7.5V7.5H16.5V5.25H18.75V21Z"
                      fill="#979797"
                    />
                  </svg>
                </i>
                Transaction History
              </Link>
            </li>
            <li>
              <Link
                className={`nav-item ${
                  activeSection === "ChallengeDetails" && "active"
                }`}
                to="/ChallengeDetails"
              >
                <i className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="24"
                    viewBox="0 0 23 24"
                    fill="none"
                  >
                    <path
                      d="M11.5 22.302C17.1896 22.302 21.802 17.6896 21.802 12C21.802 6.31028 17.1896 1.69788 11.5 1.69788C5.81028 1.69788 1.19788 6.31028 1.19788 12C1.19788 17.6896 5.81028 22.302 11.5 22.302Z"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.75671 7.96448C6.15367 7.96448 6.47546 7.64268 6.47546 7.24573C6.47546 6.84877 6.15367 6.52698 5.75671 6.52698C5.35976 6.52698 5.03796 6.84877 5.03796 7.24573C5.03796 7.64268 5.35976 7.96448 5.75671 7.96448Z"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.26173 6.7344C7.61294 5.39196 9.4289 4.62091 11.3332 4.58109C13.2375 4.54127 15.0841 5.23572 16.4903 6.5205C17.8964 7.80528 18.7543 9.58187 18.8861 11.482C19.0178 13.3822 18.4134 15.2602 17.1981 16.7267C15.9827 18.1933 14.2496 19.136 12.3581 19.3594C10.4665 19.5829 8.5615 19.0699 7.03791 17.9268C5.51433 16.7837 4.48901 15.0982 4.17447 13.2196C3.85993 11.3411 4.2803 9.41351 5.34844 7.83649"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.23742 8.93665C9.64367 8.93677 10.0332 9.09821 10.3205 9.38547C10.6078 9.67273 10.7692 10.0623 10.7693 10.4685C10.7693 10.8749 10.6079 11.2646 10.3207 11.5519C10.0334 11.8393 9.64375 12.0008 9.23742 12.0009C9.64367 12.001 10.0332 12.1625 10.3205 12.4497C10.6078 12.737 10.7692 13.1266 10.7693 13.5328C10.7692 13.9391 10.6078 14.3286 10.3205 14.6159C10.0332 14.9031 9.64367 15.0646 9.23742 15.0647L8.61499 15.0652C7.58909 15.0652 7.13245 14.9023 6.70886 14.5477M12.2308 13.0345C12.239 13.5676 12.4565 14.0761 12.8364 14.4502C13.2163 14.8243 13.7281 15.034 14.2612 15.034C14.7944 15.034 15.3062 14.8243 15.6861 14.4502C16.066 14.0761 16.2835 13.5676 16.2917 13.0345V10.965C16.2835 10.4318 16.066 9.92334 15.6861 9.54924C15.3062 9.17513 14.7944 8.96544 14.2612 8.96544C13.7281 8.96544 13.2163 9.17513 12.8364 9.54924C12.4565 9.92334 12.239 10.4318 12.2308 10.965V13.0345Z"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.70837 9.44697C7.13244 9.09334 7.59004 8.93234 8.61546 8.93522L9.23837 8.93666M7.67629 12.0009H9.23742"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </i>
                Challenge
              </Link>
            </li>
          </ul>
        </div>
        <div className="sidebar-area mobile-sidebar-area">
          <ul className="sidebar-menu">
            <li>
              <Link
                className={`nav-item ${activeSection === "Banner" && "active"}`}
                to="/"
              >
                <i className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                  >
                    <path
                      d="M10.408 0.14779C10.2897 0.0520139 10.144 0 9.994 0C9.844 0 9.6983 0.0520139 9.58 0.14779L0 7.90526L0.828667 8.99359L2 8.04511V16.6154C2.0007 16.9824 2.14141 17.3341 2.3913 17.5936C2.6412 17.8532 2.97993 17.9993 3.33333 18H16.6667C17.0201 17.9993 17.3588 17.8532 17.6087 17.5936C17.8586 17.3341 17.9993 16.9824 18 16.6154V8.05134L19.1713 8.99982L20 7.91149L10.408 0.14779ZM11.3333 16.6154H8.66667V11.0768H11.3333V16.6154ZM12.6667 16.6154V11.0768C12.6663 10.7097 12.5257 10.3577 12.2758 10.0981C12.0258 9.8385 11.6868 9.69251 11.3333 9.69214H8.66667C8.31315 9.69251 7.97422 9.8385 7.72425 10.0981C7.47428 10.3577 7.33369 10.7097 7.33333 11.0768V16.6154H3.33333V6.96578L10 1.57259L16.6667 6.9727V16.6154H12.6667Z"
                      fill="#5A5A5A"
                    />
                  </svg>
                </i>
              </Link>
            </li>
            {/* <li>
                                <Link className={`nav-item ${activeSection == 'Singup' && 'active'}`} to="/SignUp">
                                    <i className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z" fill="white"/>
                                            <path d="M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z" fill="white"/>
                                            <path d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z" fill="white"/>
                                            <path d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z" fill="white"/>
                                        </svg>
                                    </i>
                                    
                                </Link>
                            </li> */}
            <li>
              <Link
                className={`nav-item ${
                  activeSection === "ChipzBalance" && "active"
                }`}
                to="/ChipzBalance"
              >
                <i className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M2 7.625C2 6.7962 2.32924 6.00134 2.91529 5.41529C3.50134 4.82924 4.2962 4.5 5.125 4.5H18.875C19.7038 4.5 20.4987 4.82924 21.0847 5.41529C21.6708 6.00134 22 6.7962 22 7.625V16.375C22 17.2038 21.6708 17.9987 21.0847 18.5847C20.4987 19.1708 19.7038 19.5 18.875 19.5H5.125C4.2962 19.5 3.50134 19.1708 2.91529 18.5847C2.32924 17.9987 2 17.2038 2 16.375V7.625ZM5.125 5.75C4.62772 5.75 4.15081 5.94754 3.79917 6.29917C3.44754 6.65081 3.25 7.12772 3.25 7.625V9.25H20.75V7.625C20.75 7.12772 20.5525 6.65081 20.2008 6.29917C19.8492 5.94754 19.3723 5.75 18.875 5.75H5.125ZM3.25 16.375C3.25 16.8723 3.44754 17.3492 3.79917 17.7008C4.15081 18.0525 4.62772 18.25 5.125 18.25H18.875C19.3723 18.25 19.8492 18.0525 20.2008 17.7008C20.5525 17.3492 20.75 16.8723 20.75 16.375V10.5H3.25V16.375ZM15.625 14.75C15.4592 14.75 15.3003 14.8158 15.1831 14.9331C15.0658 15.0503 15 15.2092 15 15.375C15 15.5408 15.0658 15.6997 15.1831 15.8169C15.3003 15.9342 15.4592 16 15.625 16H18.375C18.5408 16 18.6997 15.9342 18.8169 15.8169C18.9342 15.6997 19 15.5408 19 15.375C19 15.2092 18.9342 15.0503 18.8169 14.9331C18.6997 14.8158 18.5408 14.75 18.375 14.75H15.625Z"
                      fill="#979797"
                    />
                  </svg>
                </i>
              </Link>
            </li>
            <li>
              <Link
                className={`nav-item ${
                  activeSection === "TransactionHistory" && "active"
                }`}
                to="/TransactionHistory"
              >
                <i className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M7.5 13.5H13.5V15H7.5V13.5ZM7.5 9.75H16.5V11.25H7.5V9.75ZM7.5 17.25H11.25V18.75H7.5V17.25Z"
                      fill="#979797"
                    />
                    <path
                      d="M18.75 3.75H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H9C8.60218 1.5 8.22064 1.65804 7.93934 1.93934C7.65804 2.22064 7.5 2.60218 7.5 3V3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V21C3.75 21.3978 3.90804 21.7794 4.18934 22.0607C4.47064 22.342 4.85218 22.5 5.25 22.5H18.75C19.1478 22.5 19.5294 22.342 19.8107 22.0607C20.092 21.7794 20.25 21.3978 20.25 21V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75ZM9 3H15V6H9V3ZM18.75 21H5.25V5.25H7.5V7.5H16.5V5.25H18.75V21Z"
                      fill="#979797"
                    />
                  </svg>
                </i>
              </Link>
            </li>
            <li>
              <Link
                className={`nav-item ${
                  activeSection === "ChallengeDetails" && "active"
                }`}
                to="/ChallengeDetails"
              >
                <i className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="24"
                    viewBox="0 0 23 24"
                    fill="none"
                  >
                    <path
                      d="M11.5 22.302C17.1896 22.302 21.802 17.6896 21.802 12C21.802 6.31028 17.1896 1.69788 11.5 1.69788C5.81028 1.69788 1.19788 6.31028 1.19788 12C1.19788 17.6896 5.81028 22.302 11.5 22.302Z"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.75671 7.96448C6.15367 7.96448 6.47546 7.64268 6.47546 7.24573C6.47546 6.84877 6.15367 6.52698 5.75671 6.52698C5.35976 6.52698 5.03796 6.84877 5.03796 7.24573C5.03796 7.64268 5.35976 7.96448 5.75671 7.96448Z"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.26173 6.7344C7.61294 5.39196 9.4289 4.62091 11.3332 4.58109C13.2375 4.54127 15.0841 5.23572 16.4903 6.5205C17.8964 7.80528 18.7543 9.58187 18.8861 11.482C19.0178 13.3822 18.4134 15.2602 17.1981 16.7267C15.9827 18.1933 14.2496 19.136 12.3581 19.3594C10.4665 19.5829 8.5615 19.0699 7.03791 17.9268C5.51433 16.7837 4.48901 15.0982 4.17447 13.2196C3.85993 11.3411 4.2803 9.41351 5.34844 7.83649"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.23742 8.93665C9.64367 8.93677 10.0332 9.09821 10.3205 9.38547C10.6078 9.67273 10.7692 10.0623 10.7693 10.4685C10.7693 10.8749 10.6079 11.2646 10.3207 11.5519C10.0334 11.8393 9.64375 12.0008 9.23742 12.0009C9.64367 12.001 10.0332 12.1625 10.3205 12.4497C10.6078 12.737 10.7692 13.1266 10.7693 13.5328C10.7692 13.9391 10.6078 14.3286 10.3205 14.6159C10.0332 14.9031 9.64367 15.0646 9.23742 15.0647L8.61499 15.0652C7.58909 15.0652 7.13245 14.9023 6.70886 14.5477M12.2308 13.0345C12.239 13.5676 12.4565 14.0761 12.8364 14.4502C13.2163 14.8243 13.7281 15.034 14.2612 15.034C14.7944 15.034 15.3062 14.8243 15.6861 14.4502C16.066 14.0761 16.2835 13.5676 16.2917 13.0345V10.965C16.2835 10.4318 16.066 9.92334 15.6861 9.54924C15.3062 9.17513 14.7944 8.96544 14.2612 8.96544C13.7281 8.96544 13.2163 9.17513 12.8364 9.54924C12.4565 9.92334 12.239 10.4318 12.2308 10.965V13.0345Z"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.70837 9.44697C7.13244 9.09334 7.59004 8.93234 8.61546 8.93522L9.23837 8.93666M7.67629 12.0009H9.23742"
                      stroke="#979797"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </i>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <button
        onClick={handleClick}
        className="navbar-toggler sidebar-nav-toggle"
        type="button"
      >
        <i class="icon" aria-hidden="true">
          <img src={require("../../static/images/mobile-menu.png")} alt="" />
        </i>
      </button>
    </>
  );
};

export default SidebarMenu;
